import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, IDoesFilterPassParams, IFilterParams, RowNode, ValueGetterParams } from 'ag-grid-community';

@Component({
  selector: 'checkbox-boolean-filter-cell',
  template: ``,
})
export class CheckBoxBooleanFilter implements IFilterAngularComp {
  // A bit clunky, but end result is ValueGetterParams.RowNode === IDoesFilterPassParams.RowNode
  private valueGetter: (rowNode: Partial<ValueGetterParams>) => any;
  public model: any;

  @ViewChild('input', { read: ViewContainerRef }) public input: any;

  agInit(params: IFilterParams): void {
    this.valueGetter = params.valueGetter;
  }

  isFilterActive(): boolean {
    return this.model !== null && this.model !== undefined && this.model !== '';
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    let value = this.valueGetter(params);
    if (this.model.filter !== '') {
      return value === this.model.filter;
    }
    return true;
  }

  getModel(): any {
    return this.model;
  }

  setModel(model: any): void {
    this.model = model ? model : '';
  }

  ngAfterViewInit(params: IAfterGuiAttachedParams): void {
    setTimeout(() => {
      if (this.input && this.input.element && this.input.element.nativeElement) {
        this.input.element.nativeElement.focus();
      }
    });
  }

  // noinspection JSMethodCanBeStatic
  componentMethod(message: string): void {
    alert(`Alert from PartialMatchFilterComponent ${message}`);
  }

  onChange(newValue: any): void {
    if (this.model.value !== newValue) {
      this.model.value = newValue;
    }
  }
}
